import { createGlobalStyle } from 'styled-components';

const DatePickerGlobalStyle = createGlobalStyle`
  .react-datepicker {
    font-size: 18px;
    min-width: 320px;
  }

  .react-datepicker__month-container {
    width: 100%;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    display: inline-block;
    width: 44px;
    line-height: 44px;
    text-align: center;
  }

  .react-datepicker__header {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .react-datepicker__current-month {
    font-size: 18px;
  }

  .react-datepicker-wrapper {
    display: block;
  }
`;

export default DatePickerGlobalStyle;
